import { FC, useRef } from 'react';
import ContentBox from 'src/components/layout/ContentBox';
import {
  Box,
  Link,
  Typography
} from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';

const NotFound: FC = () => {
  const scrollRef = useRef(null);

  return (
    <ContentBox
      scrollRef={scrollRef}
      contentRef={null}
      isBottom
      hasFooter
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        sx={{
          position: 'relative'
        }}
      >
        <Box
          sx={{
            width: '40%',
            opacity: '.1',
            left: '30%',
            aspectRatio: '1 / 1',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <img
            alt="ACCZIOM Logo"
            src="/favicon.svg"
            width="100%"
            // height="100%"
          />
        </Box>
        <Box
          sx={{
            position: 'absolute',
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Box
            sx={{
              width: '60%'
            }}
          >
            <img
              alt="404 Logo"
              src="/static/404.png"
              width="35%"
            />
            <Typography
              variant="h6"
            >
              Page not found!
            </Typography>
            <Typography
              variant="h6"
            >
              Sorry, but the page you were looking for could not be found.
            </Typography>
            <Typography
              variant="h6"
            >
              You either tried some shady route or you came here by mistake. Whichever it is, try using the navigation.
            </Typography>
            <Link
              to="/"
              component={RouterLink}
              underline="hover"
              color="primary.main"
              fontSize={18}
            >
              Go to home page
            </Link>
          </Box>
        </Box>
      </Box>
    </ContentBox>
  );
};

export default NotFound;
